import { RoundItem } from "../../../../base-react/models/rounds";
export const groupClassRoundsIntoChildren = (list) => {
    let _filteredRounds = list.filter((round) => !RoundItem.isChildRound(round));
    _filteredRounds = _filteredRounds.map((round) => {
        function buildChildren(data, currentChild) {
            //Creating current child object
            var child = {
                ...currentChild,
                rowKey: currentChild.round_id,
                children: []
            };
            //Looking for childrens in all input data
            var currentChildren = data.filter((item) => item.round_parent_id == child.round_id);
            if (currentChildren.length > 0) {
                currentChildren.forEach(function (item) {
                    //Iterating threw children and calling the recursive function
                    //Adding the result to our current children
                    child.children.push(buildChildren(data, item));
                });
            }
            if (child.children.length == 0) {
                delete child.children;
            }
            return child;
        }
        return buildChildren(list, round);
    });
    return _filteredRounds;
};
